/* eslint-disable */
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";
import { auth } from '../../firebase';
import AuthUserContext from 'components/AuthUserContext/AuthUserContext';

import NavigationAuth from './NavigationAuth';
import NavigationNonAuth from './NavigationNonAuth';

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import List from "material-ui/List";
import ListItem from "material-ui/List/ListItem";
import Tooltip from "material-ui/Tooltip";


// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";
import SignOutButton from "components/CustomButtons/SignOutButton.jsx";
import IconButton from "components/CustomButtons/IconButton.jsx";

import navigationStyle from "assets/jss/material-kit-react/components/navigationStyle.jsx";


const Navigation = () =>
  <AuthUserContext.Consumer>
    {authUser => authUser
      ? <NavigationAuth />
      : <NavigationNonAuth />
    }
  </AuthUserContext.Consumer>



export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Header/Navigation.jsx